"use client"

import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { ImageCardProps, RenderConfig } from "./RenderConfig"

export const ImageCard: ComponentConfig<ImageCardProps> = {
  label: "Image Card",
  fields: {
    image: {
      label: "Image",
      type: "custom",
      render: props => <ImageUploadField {...props} />,
    },
    title: {
      label: "Title",
      type: "text",
    },
    url: {
      label: "Link",
      type: "text",
    },
    justifyContent: {
      label: "Justify Content",
      type: "select",
      options: [
        { value: "flex-start", label: "Start" },
        { value: "center", label: "Center" },
        { value: "flex-end", label: "End" },
        { value: "space-around", label: "Space Around" },
        { value: "space-between", label: "Space Between" },
      ],
    },
    alignItems: {
      label: "Align Items",
      type: "select",
      options: [
        { value: "baseline", label: "Baseline" },
        { value: "flex-start", label: "Start" },
        { value: "center", label: "Center" },
        { value: "flex-end", label: "End" },
        { value: "stretch", label: "Stretch" },
      ],
    },
    fontSizeMobile: {
      label: "Font Size Mobile",
      type: "text",
    },
    fontSizeDesktop: {
      label: "Font Size Desktop",
      type: "text",
    },
    fontWeightMobile: {
      label: "Font Weight Mobile",
      type: "text",
    },
    fontWeightDesktop: {
      label: "Font Weight Desktop",
      type: "text",
    },
    lineHeightMobile: {
      label: "Line Height Mobile",
      type: "text",
    },
    lineHeightDesktop: {
      label: "Line Height Desktop",
      type: "text",
    },
    paddingTextMobile: {
      label: "Padding Text Mobile",
      type: "text",
    },
    paddingTextDesktop: {
      label: "Padding Text Desktop",
      type: "text",
    },
    className: {
      label: "Class Name",
      type: "text",
    },
    backgroundColor: {
      label: "Background Color",
      type: "text",
    },
    color: {
      label: "Text Color",
      type: "text",
    },
  },
  defaultProps: {
    title: "Title",
    justifyContent: "center",
    alignItems: "center",
    fontSizeMobile: "16px",
    fontSizeDesktop: "24px",
    fontWeightMobile: "400",
    fontWeightDesktop: "600",
    lineHeightMobile: "22px",
    lineHeightDesktop: "36px",
    paddingTextDesktop: "24px",
    paddingTextMobile: "16px",
    className: "",
    backgroundColor: "white",
  },
  ...RenderConfig,
}
